import { Routes } from '@angular/router';
import { adminGuard } from './core/guards/admin.guard';
import { authGuard } from './core/guards/auth.guard';
import { permissionGuard } from './core/guards/permission.guard';
import { LayoutComponent } from './layout/layout.component';
import { DynamicContentEmbeddedComponent } from './modules/auth/pages/dynamic-content-embedded/dynamic-content-embedded.component';
import { ProfileComponent } from './modules/auth/pages/profile/profile.component';
import { ResetPasswordComponent } from './modules/not-auth/authentication/reset-password/reset-password.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./modules/not-auth/authentication/authentication.routes'),
  },
  {
    path: 'resetPassword/:token',
    component: ResetPasswordComponent,
  },
  {
    path: 'auth',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'admin',
        loadChildren: () =>
          import('./modules/system-admin/system-admin.routes'),
        canActivate: [adminGuard],
      },
      {
        path: 'admin-system',
        loadChildren: () =>
          import(
            './modules/system-admin/administrative-system/administrative-system.routes'
          ),
        canActivate: [adminGuard],
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/dashboard/dashboard.component').then(
            x => x.DashboardComponent
          ),
      },
      {
        path: 'commissioning',
        loadChildren: () =>
          import('./modules/auth/pages/commissioning/commissioning.routes'),
        canActivate: [permissionGuard],
        data: { module: 'entregaTecnica' },
      },
      {
        path: 'mandatory-reviews',
        loadChildren: () =>
          import(
            './modules/auth/pages/mandatory-reviews/mandatory-reviews.routes'
          ),
        canActivate: [permissionGuard],
        data: { module: 'revisaoObrigatoria' },
      },
      {
        path: 'periodic-reviews',
        loadChildren: () =>
          import(
            './modules/auth/pages/periodic-reviews/periodic-reviews.routes'
          ),
        canActivate: [permissionGuard],
        data: { module: 'revisaoPeriodica' },
      },
      {
        path: 'commissioning-analysis',
        loadChildren: () =>
          import(
            './modules/auth/pages/commissioning-analysis/commissioning-analysis.routes'
          ),
        canActivate: [permissionGuard],
        data: { module: 'analise.entregaTecnica' },
      },
      {
        path: 'history',
        loadChildren: () =>
          import('./modules/auth/pages/history/history.routes'),
      },
      {
        path: 'embedded-content',
        component: DynamicContentEmbeddedComponent,
      },
      {
        path: 'profile',
        component: ProfileComponent,
      },
      {
        path: 'admeasurement',
        loadChildren: () =>
          import(
            './modules/system-admin/admin-admeasurement/admeasurement.routes'
          ),
        canActivate: [permissionGuard],
        data: { module: 'afericao.pivoCentral' },
      },
      {
        path: 'resizing',
        loadChildren: () =>
          import('./modules/auth/pages/resizing/resizing.routes'),
        canActivate: [permissionGuard],
        data: { module: 'redimensionamento.pivoCentral' },
      },
      {
        path: 'letter-justification',
        loadChildren: () =>
          import(
            './modules/auth/pages/letter-justification/letter-justification.routes'
          ).then(m => m.LETTER_ROUTES),
        canActivate: [permissionGuard],
        data: { module: 'cartaJustificativaMontagem' },
      },
      {
        path: 'letter-justification-analysis',
        loadChildren: () =>
          import(
            './modules/auth/pages/letter-justification-analysis/letter-justification-analysis.routes'
          ),
        canActivate: [permissionGuard],
        data: { module: 'analise.cartaJustificativa' },
      },
      {
        path: 'valley-manager',
        loadChildren: () =>
          import('./modules/auth/pages/valley-manager/valley-manager.routes'),
        canActivate: [permissionGuard],
        data: { module: 'valleyManager' },
      },
    ],
  },
];
